import { IFavoritesState } from '../../types/favorites';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EFavoritesActionTypes {
  LoadingUserFavorites = 'favorites/loading-user-favorites',
  UpdateUserFavorites = 'favorites/update-user-favorites',
  FailedUserFavorites = 'favorites/failed-user-favorites',
  InvalidateUserFavorites = 'favorites/invalidate-user-favorites',
  ResetUserFavorites = 'favorites/reset-user-favorites',
}

export interface IUserFavoritesRequestPayload {
  requestId: number;
}

export interface IUpdateUserFavoritesPayload extends IUserFavoritesRequestPayload {
  favoriteItems: IFavoritesState['favoriteItems'];
}

export type TLoadingUserFavorites = ITypedReduxAction<
  EFavoritesActionTypes.LoadingUserFavorites,
  IUserFavoritesRequestPayload
>;
export type TUpdateUserFavorites = ITypedReduxAction<
  EFavoritesActionTypes.UpdateUserFavorites,
  IUpdateUserFavoritesPayload
>;
export type TFailedUserFavorites = ITypedReduxAction<
  EFavoritesActionTypes.FailedUserFavorites,
  IUserFavoritesRequestPayload
>;
export type TInvalidateUserFavorites = ITypedReduxAction<EFavoritesActionTypes.InvalidateUserFavorites>;
export type TResetUserFavorites = ITypedReduxAction<EFavoritesActionTypes.ResetUserFavorites>;

export type TFavoritesActions =
  | TLoadingUserFavorites
  | TUpdateUserFavorites
  | TFailedUserFavorites
  | TInvalidateUserFavorites
  | TResetUserFavorites;
